module.exports = __webpack_public_path__ + "media/images/flags/gb-wls-a69b6bb076d89808e06433d79c9d3d6d.svg";